import DashboardPassportFileTable from "./DashboardPassportFileTable";

export default DashboardPassportFileTable;
